import React from 'react'
import { useTranslation } from 'react-i18next'
import Images from '../../assets/images'
import './Modules.css'
import Users from './Users'

const MODULE_ICON_KEYS = [
  'tournaments',
  'message',
  'assitance',
  'evaluations',
  'photos',
  'documents',
  'events',
  'calendar',
  'chat',
  'shop',
  'payments',
  'app',
]

const Modules = () => {
  const { t } = useTranslation()
  const items = t('academyModules.items', { returnObjects: true }) || []

  return (
    <section className='academy-modules'>
      <div className='academy-modules-content'>
        <h2>{t('academyModules.title')}</h2>

        <div className='academy-modules-grid'>
          {items.map((item, index) => {
            const iconKey = MODULE_ICON_KEYS[index]
            const toneClass = `tone-${(index % 4) + 1}`

            return (
              <article key={index} className={`academy-module-card ${toneClass}`}>
                <div className='module-icon-wrap'>
                  <img src={Images.academy.modules[iconKey]} alt='' aria-hidden='true' />
                </div>
                <p>{item}</p>
              </article>
            )
          })}
        </div>
      </div>
      <Users />
    </section>
  )
}

export default Modules
